import { useState } from 'react';
import { initialValues, SearchFormValues } from '../schema';
import { useBangKeHoaDonBanHangContext } from '../context';

export const useDialogState = () => {
  const [initialSearchDialogOpen, setInitialSearchDialogOpen] = useState(true);
  const [editPrintTemplateDialogOpen, setEditPrintTemplateDialogOpen] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [searchParams, setSearchParams] = useState<SearchFormValues>(initialValues);
  const { setQueryParams, exportToExcel } = useBangKeHoaDonBanHangContext();

  const handleInitialSearch = async (
    formData: SearchFormValues,
    getReport: (params: BanHangTableParams) => Promise<void>
  ) => {
    try {
      await getReport(formData);
      setSearchParams(formData);
      setQueryParams(formData);
      setInitialSearchDialogOpen(false);
      setShowTable(true);
      handleInitialSearchClose();
    } catch (e) {
      return;
    }
  };

  const handleRefreshClick = async (getReport: (params: BanHangTableParams) => Promise<void>) => {
    if (searchParams) {
      await getReport(searchParams);
    }
  };

  const handleInitialSearchClose = () => {
    setInitialSearchDialogOpen(false);
  };

  const handleSearchClick = () => {
    setInitialSearchDialogOpen(true);
  };

  const handleEditPrintTemplateClick = () => {
    setEditPrintTemplateDialogOpen(true);
  };

  const handleClosePrintTemplateDialog = () => {
    setEditPrintTemplateDialogOpen(false);
  };

  const handleSavePrintTemplate = (_template: BanHangPayload) => {
    setEditPrintTemplateDialogOpen(false);
  };

  const handleRowClick = (_row: BanHangRecord) => {};

  const handleFixedColumnsClick = () => {};

  const handleExportDataClick = () => exportToExcel();

  return {
    // State
    initialSearchDialogOpen,
    editPrintTemplateDialogOpen,
    showTable,
    searchParams,

    // Handlers
    handleInitialSearch,
    handleRefreshClick,
    handleInitialSearchClose,
    handleSearchClick,
    handleEditPrintTemplateClick,
    handleClosePrintTemplateDialog,
    handleSavePrintTemplate,
    handleRowClick,
    handleFixedColumnsClick,
    handleExportDataClick
  };
};
